@import (reference) '../../../../../../../constants/spacing.module.less';

.product-column-header {
  padding-left: 80px;
}

.product-cell {
  position: relative;
  align-items: flex-start;
  flex-wrap: nowrap;
}

.product-cell-empty {
  min-height: @space-40;
}

.product-cell > img,
.product-cell > span {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.image-placeholder {
  width: 40px;
  height: 40px;
  background-color: var(--white);
  border-radius: 4px;
}

.no-image-placeholder {
  display: block;
  width: 40px;
  height: 40px;
  background-color: var(--grey-400);
  border-radius: 4px;
}

.product-info {
  margin-left: @space-12;
  min-width: 0;
}

.product-name {
  display: block;
  line-height: initial;
  font-weight: 500;
  margin-bottom: @space-4;
  text-align: left;
  word-break: break-word;
}

.product-sku {
  font-size: 12px;
  word-break: break-word;
}

.location-unavailable {
  display: inline-flex;
  align-items: center;
  gap: @space-4;
  cursor: pointer;
}

.warning-icon {
  color: var(--orange-F59E0B);
  font-size: 12px;
}

.warning-text {
  font-size: 14px;
}
